import Trans from 'next-translate/Trans'
import Countdown from 'react-countdown'
import { OFFER_STATUS_WAITING_COUNTER_PART } from 'tennders-stracture/libs/constants'
import { SingleOfferTimer } from '../SingleOfferTimer'

export const DealConfirm = ({ offer }) => (
  offer?.timer && offer?.status?.label === OFFER_STATUS_WAITING_COUNTER_PART
    ? (
      <div className="tennders-under-neg-confirm-congrats bg-color-s p-16 br-6">
        <strong>
          <Countdown
            date={Date.now() + offer.timer * 1000}
            renderer={SingleOfferTimer}
          />
        </strong>
        <div className="mb-10">
          <Trans i18nKey="offer:confirmedDeal" />
          {' '}
          {' '}
          <strong>
            <Trans i18nKey="offer:otherPart" />
          </strong>
          {' '}
          {' '}
          <Trans i18nKey="offer:needsConfirm" />
        </div>
      </div>
    ) : null
)
